<template>
  <div class="span fixed-top" v-if="$store.getters['Loading/loadingStatus']">
    <b-progress id="loading-3" :value="percent($store.getters['Loading/requestCounter'])" :max="100" class="p-0 m-0"
                height="7px"></b-progress>
  </div>
</template>

<script>
export default {
  name: "Loading3",
  methods: {
    percent(value) {
      value = (100 / (value + 0.04))
      return value
    }
  },
}
</script>

<style>
#loading-3 .progress-bar {
  background: var(--secondary) !important;
}
</style>

<style scoped>
#loading-3 {
  background: #1f1e1e;
}
</style>
